import data from "../../../../../packages/react/src/drafts/Tooltip/Tooltip.docs.json";
import * as React from 'react';
export default {
  data,
  React
};